import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
//
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
//
import PopupEdit from "../../common/PopupEdit";
import CommonListItem from "../../common/CommonListItem";
import CommonList from "../../common/CommonList";
import PopupListItem from "../../common/PopupListItem";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import IconPopup from "../../../../../../common/components/popup/IconPopup";
import { StoreContext } from "../../../../../../store/StoreProvider";
import useDebounce from "../../../../../../common/hooks/useDebounce";
import useModuleLimit from "../../../../../hooks/useModuleLimit";
//
import { MODULE_ID } from "../../../../../../config/CONSTANTS";
import urls from "../../../../../../api/project/ApiUrls";
import { isEmpty } from "../../../../../../common/utils";
// hook
import Act from "../../../../../../store/actions";
import fireDb from "../../../../../../api/firebase/realtime/utils";
import fireAuth from "../../../../../../api/firebase/auth/utils";
import defaultGroupIcon from "../../../../../../../images/avatar_group/avatar_group.svg";
import {
  deleteUserGroup,
  getOneGroupFromGroups,
} from "../../../../service/userGroupService";
import { isMemberFilter } from "../../../../service/utils";

const popupMenuPosition = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
};

const StyledList = CommonList;

const AccordionDetailChildren = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale, group, groups } = user;
  // local state
  const [listItems, setListItems] = useState([]);
  const [listItemFocus, setListItemFocus] = useState(null);
  const [popupPageIdx, setPopupPageIdx] = useState(0);
  const [popPageCtx, setPopPageCtx] = useState({});
  const [popEditInput, setPopEditInput] = useState("");

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();
  const { handleLimit } = useModuleLimit();

  const disabledListItemMoreAct = (uGroup) =>
    !(
      handlePublic(MODULE_ID.snaSidebarGroupsEditgroup) &&
      fireAuth.isGroupAdmin(uGroup)
    );

  //
  useEffect(() => {
    if (!isEmpty(groups)) {
      // fetchListItems();
      const userGroupsFiltered = Object.entries(groups)
        .filter(isMemberFilter)
        .map(([uid, valObj]) => valObj);
      setListItems(
        userGroupsFiltered.map((item, idx) => ({
          ...item,
          id: item?.uid,
        }))
      );
    }
  }, [groups]);

  const handleDeleteListItem = (itemInfo) => () => {
    const successDeleteCallback = () => {
      dispatch({
        type: Act.COMMON_SET_SUCCESS_MESSAGE,
        payload: {
          open: true,
          content: intl.formatMessage({
            id: "sna.sidebar.grouptool.delete.group.success",
            defaultMessage: "刪除團隊成功",
          }),
        },
      });

      // 過濾掉已刪除的 group
      const newGroups = Object.entries(groups)
        .filter(
          ([groupKey, valObj]) =>
            valObj.isMember && valObj?.uid !== itemInfo?.uid
        )
        .reduce((acc, [groupKey, valObj]) => {
          acc[groupKey] = valObj;
          return acc;
        }, {});
      // 儲存成功的話重新抓取 user groups 資料
      dispatch({
        type: Act.USER_SET_GROUPS,
        payload: newGroups,
      });
      const theSameAsCurGroup = group?.uid === itemInfo?.uid;
      if (theSameAsCurGroup) {
        const oneGroupId = Object.keys(newGroups)[0];
        getOneGroupFromGroups(oneGroupId, user?.uid, dispatch);
      }
    };

    const failureDeleteCallback = (err) => {
      dispatch({
        type: Act.COMMON_SET_ERROR_MESSAGE,
        payload: {
          open: true,
          payload: {
            open: true,
            content: err.message,
          },
        },
      });
    };

    // 儲存至 firebase, 儲存成功的話重新抓取 user groups 資料
    if (listItems.length <= 1) {
      // 彈跳視窗 => groups 必須 >= 1
      dispatch({
        type: Act.SNA_DIALOG_CONTEXT,
        payload: {
          openSignal: true,
          title: intl.formatMessage({
            id: "sna.sidebar.grouptool.delete.group.notallowable.modal.title",
            defaultMessage: "無法刪除團隊？",
          }),
          contentText: intl.formatMessage({
            id: "sna.sidebar.grouptool.delete.group.notallowable.modal.text",
            defaultMessage: "團隊數不可小於1。。",
          }),
          yesText: intl.formatMessage({
            id: "sna.sidebar.grouptool.delete.group.notallowable.modal.confirm",
            defaultMessage: "好",
          }),
        },
      });
    } else {
      dispatch({
        type: Act.SNA_DIALOG_CONTEXT,
        payload: {
          openSignal: true,
          title: intl.formatMessage({
            id: "sna.sidebar.grouptool.delete.group.modal.title",
            defaultMessage: "確定要刪除團隊嗎？",
          }),
          contentText: intl.formatMessage({
            id: "sna.sidebar.grouptool.delete.group.modal.text",
            defaultMessage: "刪除後將無法復原此團隊。",
          }),
          onYes: () =>
            deleteUserGroup({
              groupId: itemInfo?.uid,
              userId: user?.uid,
              onSuccess: successDeleteCallback,
              onFailure: failureDeleteCallback,
            }),
          yesText: intl.formatMessage({
            id: "sna.sidebar.grouptool.delete.group.modal.confirm",
            defaultMessage: "刪除",
          }),
          noText: intl.formatMessage({
            id: "sna.sidebar.grouptool.delete.group.modal.cancel",
            defaultMessage: "取消",
          }),
        },
      });
    }
  };

  const handleEditInputChange = (e) => {
    setPopEditInput(e.target.value);
  };

  const handleEditSubmit = () => {
    fireDb.updateGroup({
      uid: listItemFocus?.uid,
      data: {
        displayName: popEditInput,
      },
      onSuccess: () => {
        dispatch({
          type: Act.COMMON_SET_SUCCESS_MESSAGE,
          payload: {
            open: true,
            content: intl.formatMessage({
              id: "sna.sidebar.grouptool.edit.groupname.success",
              defaultMessage: "修改團隊名稱成功",
            }),
          },
        });
        // 重新抓取 user groups 的資料
        dispatch({
          type: Act.USER_REFRESH_USER_GROUPS,
          payload: true,
        });
      },
      onError: (err) => {
        dispatch({
          type: Act.COMMON_SET_ERROR_MESSAGE,
          payload: {
            open: true,
            content: err.message,
          },
        });
      },
    });
  };

  const getPopupPageEditGroup = () => ({
    children: (
      <PopupListItem
        text={intl.formatMessage({
          id: "sna.sidebar.grouptool.edit.groupname",
          defaultMessage: "重新命名",
        })}
        onClick={() => setPopupPageIdx(1)}
        withNextStep
      />
    ),
  });

  const getPopupPageDeleteGroup = () => ({
    children: (
      <PopupListItem
        text={intl.formatMessage({
          id: "sna.sidebar.grouptool.delete.group",
          defaultMessage: "刪除團隊",
        })}
        onClick={handleDeleteListItem(listItemFocus)}
        withNextStep={false}
      />
    ),
  });

  const popupPage0 = {
    body: [getPopupPageEditGroup(), getPopupPageDeleteGroup()].filter(
      (item) => !!item
    ),
  };

  const isGroupNameDuplicate =
    Object.values(groups || {}).filter((g) => g.displayName === popEditInput)
      .length > 0;
  // 加入其他判斷條件, e.g. 團隊名稱不可重複
  const disabledEditSubmitBtn = !popEditInput || isGroupNameDuplicate;
  const popupPage1 = {
    // body: popup 主體
    body: (
      <PopupEdit
        context={listItemFocus}
        title={intl.formatMessage({
          id: "sna.sidebar.grouptool.edit.groupname",
          defaultMessage: "重新命名",
        })}
        inputLabel={intl.formatMessage({
          id: "sna.sidebar.grouptool.groupname.input.label",
          defaultMessage: "團隊名稱",
        })}
        onInputChange={handleEditInputChange}
        onSubmit={() => handleEditSubmit()}
        submitText={intl.formatMessage({
          id: "sna.sidebar.grouptool.groupname.confirm",
          defaultMessage: "確認",
        })}
        disabledBtn={disabledEditSubmitBtn}
      />
    ),
    // footer
    footer: null,
  };

  // popup 所有分頁
  const popupPages = [popupPage0, popupPage1];

  // 當選擇的 group 變更 or pageIdx 便更時, 重新產生 popup 內容
  useEffect(() => {
    setPopPageCtx(popupPages[popupPageIdx]);
  }, [popupPageIdx, popEditInput, listItemFocus, listItems]);

  const getIconButtonProps = (uGroup) => ({
    onButtonIconClick: () => {
      setListItemFocus(uGroup);
    },
    sx: {
      color: "#fff",
    },
    disabled: disabledListItemMoreAct(uGroup),
  });

  const getMenuProps = () => ({
    ...popPageCtx,
    ...popupMenuPosition,
    onClose: () => setPopupPageIdx(0),
  });

  const handleListItemClick = (uGroup) => (e) => {
    // console.log("uGroup", uGroup);
    getOneGroupFromGroups(uGroup?.uid, user?.uid, dispatch);
  };

  const getImgSrc = (uGroup) => {
    const defaultGroupName = "預設團隊";
    const groupName = uGroup.name || uGroup.displayName;
    if (groupName === defaultGroupName) {
      return defaultGroupIcon;
    }
    return null;
  };

  return (
    <StyledList>
      {listItems.map((uGroup, idx) => (
        <CommonListItem
          key={idx.toString()}
          withAvatar
          context={{
            id: uGroup?.uid,
            textPrimary: uGroup.displayName,
            imgSrc: getImgSrc(uGroup),
          }}
          onListItemClick={handleListItemClick(uGroup)}
          avatarSize="normal"
          secondaryAction={
            <IconPopup
              icon={<MoreHorizIcon />}
              iconButtonProps={{
                ...getIconButtonProps(uGroup),
              }}
              menuProps={{
                ...getMenuProps(),
              }}
            />
          }
          darkMode
        />
      ))}
    </StyledList>
  );
};

export default AccordionDetailChildren;
